<template>
  <!-- 查询条件 -->
  <el-row>
    <el-col :span="18">
      <el-form inline @submit.prevent="query(1)">
        <el-form-item label="时间">
          <el-date-picker
            v-model="queryParams.time"
            end-placeholder="结束时间"
            range-separator="至"
            start-placeholder="开始时间"
            type="daterange"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
      </el-form>
    </el-col>
    <el-col align="right" :span="6">
      <el-button icon="search" type="primary" @click="query()">查询</el-button>
      <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
    </el-col>
  </el-row>

  <!-- 表格 -->
  <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
    <el-table-column label="类型" prop="reason" />
    <el-table-column label="扣分" prop="score" />
    <el-table-column label="时间" prop="time" />
    <template #empty>
      <el-empty class="vab-data-empty" description="暂无数据" />
    </template>
  </el-table>

  <!-- 分页 -->
  <el-pagination
    v-model:current-page="queryParams.pageNum"
    background
    layout="prev, pager, next"
    :page-size="queryParams.pageSize"
    :total="queryParams.total"
    @current-change="query"
  />
</template>

<script setup>
  import { ref, reactive, onMounted, defineProps, watchEffect } from 'vue'
  import { omit } from 'lodash'
  import { getViolationDetail } from '@/api/jbh'

  const props = defineProps({
    uid: {
      type: [String, Number],
      required: true,
    },
  })

  const defaultQueryParams = {
    time: [],
    startTime: '',
    endTime: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }
  const queryParams = reactive({ ...defaultQueryParams })

  watchEffect(() => {
    const [start, end] = queryParams.time
    if (start) queryParams.startTime = start
    if (end) queryParams.endTime = end
  })

  const loading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    query()
  })

  function getList(params) {
    console.log('query params', params)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          code: 200,
          data: {
            total: 5,
            list: [
              {
                id: 1,
                reason: '智能标记',
                score: -10,
                time: '2025.4.20 14:50',
              },
              {
                id: 2,
                reason: '智能标记',
                score: -10,
                time: '2025.4.20 14:51',
              },
              {
                id: 3,
                reason: '智能标记',
                score: -10,
                time: '2025.4.20 14:52',
              },
            ],
          },
        })
      }, 500)
    })
  }

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total', 'time'),
      pageNum,
      uid: props.uid,
    }

    loading.value = true

    getViolationDetail(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }
</script>

<style lang="scss" scoped></style>
